import { getToken } from "../../../services/authService";

const API = process.env.REACT_APP_API_URL;

const authHeaders = () => {
    const t = getToken();
    return { Authorization: `Bearer ${t}` };
};

export async function fetchTiposDocumento() {
    const res = await fetch(`${API}/api/enums/tipos-documento`, { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchTipoArmas() {
    const res = await fetch(`${API}/api/enums/tipo-armas`, { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchTipoLicencias() {
    const res = await fetch(`${API}/api/enums/tipo-licencias`, { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchAlergenosAll() {
    const res = await fetch(`${API}/api/alergenos/all`, { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}
